export const AXIS_AUTO_SIZE_PADDING = 4;
export const AXIS_AUTO_SIZE_MIN = 20;
export const AXIS_AUTO_SIZE_TICK_SIZE = 6;
export const AXIS_AUTO_SIZE_TICK_LABEL_GAP = 2;
export const AXIS_AUTO_SIZE_GROUP_GAP = 4;
